import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { getUsers } from "../actions/studensts";
import StudentLink from "./StudentLink";

export default function StudentData({ students }) {
  const [allUsers, setAllUsers] = useState([]);
  const [selected, setSelected] = useState("all");
  const user = JSON.parse(localStorage.getItem("profile")).value[0];
  const pathname_one = useLocation().pathname.split("/")[2];

  const handleSelect = async (username) => {
    let newSelected = selected;
    newSelected = username;
    setSelected(newSelected);
  };

  const getAllUsers = async () => {
    const { data } = await getUsers();
    if (data) {
      const result = data.users;
      setAllUsers(result);
    }
  };

  function Filtered() {
    const result = students?.filter(
      (student) => student.invoice_user === selected,
    );
    return (
      <>
        <span
          className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-indigo-600/20 border border-indigo-500/30 text-indigo-300 text-sm font-bold mb-4"
        >
          {result?.length}
        </span>

        {result?.map((element) => (
          <StudentLink element={element} key={element.passport_number} />
        ))}
        {students?.length === 0 && (
          <h1
            className="w-full my-2 border border-red-500/30 py-2.5 px-5 rounded-xl bg-red-500/10 flex items-center justify-between text-sm font-medium text-red-400"
          >
            No Student Available...
          </h1>
        )}
      </>
    );
  }

  function DataFiltered() {
    const result = students?.filter(
      (student) => student.invoice_user === user.username,
    );
    return (
      <>
        <span
          className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-indigo-600/20 border border-indigo-500/30 text-indigo-300 text-sm font-bold mb-4"
        >
          {result?.length}
        </span>

        {result?.map((element) => (
          <StudentLink element={element} key={element.passport_number} />
        ))}
        {students?.length === 0 && (
          <h1
            className="w-full my-2 border border-red-500/30 py-2.5 px-5 rounded-xl bg-red-500/10 flex items-center justify-between text-sm font-medium text-red-400"
          >
            No Student Available...
          </h1>
        )}
      </>
    );
  }

  useEffect(() => {
    getAllUsers();
  }, []);

  return (
    <>
      {user.role === "user" && pathname_one !== "auditing" ? (
        <DataFiltered />
      ) : (
        <>
          {pathname_one === "auditing" && user.role !== "admin" ? (
            <span
              className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-indigo-600/20 border border-indigo-500/30 text-indigo-300 text-sm font-bold mb-4"
            >
              {students?.length}
            </span>
          ) : (
            ""
          )}
          {pathname_one !== "auditing" && (
            <div className="mb-4 flex items-center gap-2">
              <label htmlFor="users" className="text-slate-400 text-sm">
                Filter by user:
              </label>
              <select
                className="bg-slate-800 border border-slate-600 text-white text-sm rounded-lg px-3 py-1.5 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                onChange={(e) => handleSelect(e.target.value)}
                id="users"
              >
                <option value="all">All</option>
                {allUsers?.map((user, i) => (
                  <option value={user.username} key={i}>
                    {user.username}
                  </option>
                ))}
              </select>
            </div>
          )}
          {selected === "all" ? (
            <>
              {students?.map((element) => (
                <StudentLink element={element} key={element.passport_number} />
              ))}
              {students?.length === 0 && (
                <h1
                  className="w-full my-2 border border-red-500/30 py-2.5 px-5 rounded-xl bg-red-500/10 flex items-center justify-between text-sm font-medium text-red-400"
                >
                  No Student Available...
                </h1>
              )}
            </>
          ) : (
            <Filtered />
          )}
        </>
      )}
    </>
  );
}
